import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { SessionService } from '@src/services';
import { projectActions } from '@src/store/reducers/projectReducer';
import { databasesActions } from '@src/store/reducers/databasesReducer';

@Component({
    selector: 'environment-databases',
    template: require('./environment-databases.component.html'),
    styles: [require('./environment-databases.component.scss')]
})
export class EnvironmentDatabasesComponent implements OnInit, OnDestroy {
    public selectedItem = 0;

    public projectId: any;
    public envID: any;
    public databases: any;
    public environmentItem: any;

    private unsubscribe: any;
    private unsubscribe1: any;

    constructor(private store: Store,
        @Inject('$stateParams') $stateParams: any,
        @Inject('$state') private $state: any,
        private sessionService: SessionService) {
        this.projectId = $stateParams.id;
        this.envID = $stateParams.envID;
        this.unsubscribe1 = this.store.subscribe(() => {
            this.databases = this.store.getState().schemas.items;
            if (this.databases.length > 0) {
                this.getProperties(this.databases[0]);
                this.unsubscribe1();
            }
        });
    }

    public async ngOnInit() {
        await this.store.dispatch({
            type: databasesActions.GET_SCHEMAS,
            payload: { projectId: this.projectId, envID: this.envID }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe1();
        delete window['dbTypeId'];
        this.store.dispatch({ type: databasesActions.RESET_SCHEMAS_PROPERTIES });
    }

    public async getProperties(data: any) {
        this.environmentItem = null;
        const payload = { projectId: this.projectId, envID: this.envID, schemaId: data.id };
        const schemaProperties = await this.store.dispatch({ payload, type: databasesActions.GET_SCHEMA_PROPERTIES });
        if (schemaProperties) {
            if(schemaProperties.connectionProperties)
            {
                Object.keys(schemaProperties.connectionProperties).forEach(element => {
                    schemaProperties.connectionProperties[element] = schemaProperties.connectionProperties[element] == null ? "" : schemaProperties.connectionProperties[element];
                });
            }
            this.environmentItem = schemaProperties;
            this.environmentItem.name = data.name;
        }
    }

    public onTest(data: any) {
        this.environmentItem.status = data.status = '';
        this.unsubscribe = this.store.subscribe(() => {
            if (this.store.getState().schemas.status) {
                this.environmentItem.status = data.status = this.store.getState().schemas.status;
                this.unsubscribe();
            }
        });

        const payload = {
            projId: this.projectId,
            envId: this.envID,
            schemaId: this.environmentItem.id,
            params: this.environmentItem.connectionProperties
        };
        this.store.dispatch({ payload, type: databasesActions.TEST_CONNECT_TO_SCHEMA });
    }

    public onSave(data: any) {
        this.environmentItem = data;
        const payload = {
            projectId: this.projectId,
            envID: this.envID,
            schemaId: this.environmentItem.id,
            params: this.environmentItem
        };
        this.store.dispatch({ payload, type: databasesActions.SAVE_SCHEMA_PROPERTIES });
    }

    public async onEditLink() {
        await this.store.dispatch({
            type: projectActions.GET_EDIT_PROJECT,
            payload: { projectId: this.projectId },
            callback: (response: any) => {
                const name = `${response.data.name} (Draft)`;
                this.sessionService.set(`project_${response.data.id}`, name);
                this.$state.go('app.authorized.environments', { name, id: response.data.id });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-databases/environment-databases.component.ts